define('constants/userGroupConstants',[], function() {
    return {
        allUserGroupId:  "systemGroup-allUsers",
        billingAdminsGroupId: "systemGroup-billingAdmins",
        systemAdminsGroupId: "systemGroup-systemAdmins"
    };
});
